export const TEMPLATE_BACKGROUND_ID = 'template-background';
